import React from 'react';
import { AnnualEnrollmentProps } from '../../arc/models/arc-epi-props';
import { AnnualEnrollmentState } from '../models/annual-enrollment-models';
import { DividerSection } from '../../../global/components/layout/divider-section';
import { WysiwygWithReactLink } from '../../../global/components/wysiwyg-with-react-link';
import { MyCPGCoverageCostSummary } from './mycpg-coverage-cost-summary';

interface Props {
    AEState: AnnualEnrollmentState;
    AEProps: AnnualEnrollmentProps;
    selectedMedicalPlan: string;
    selectedDentalPlan: string;
    showNotApplicable: boolean;
}

export function AnnualEnrollmentSummary(props: Props) {
	const { AEState, AEProps, selectedDentalPlan, selectedMedicalPlan, showNotApplicable } = props;
    const selectedMedicalTier = AEState.tierCalculations?.M?.selected_tier || '';
    const selectedDentalTier = AEState.tierCalculations?.D?.selected_tier || '';

    const medicalRate = selectedMedicalTier ? (AEState.AEInfo?.offerings?.M?.plans?.filter(x => x.code === selectedMedicalPlan)[0]?.rates_by_tier[selectedMedicalTier] || 0) : 0;
    const dentalRate = selectedDentalTier ? (AEState.AEInfo?.offerings?.D?.plans?.filter(x => x.code === selectedDentalPlan)[0]?.rates_by_tier[selectedDentalTier] || 0) : 0;
    const selectedMedicalPlanName = AEState.AEInfo?.offerings?.M?.plans?.filter(x => x.code === selectedMedicalPlan)[0]?.name;
    const selectedDentalPlanName = AEState.AEInfo?.offerings?.D.plans?.filter(x => x.code === selectedDentalPlan)[0]?.name;

    return (
        <>
            {
                showNotApplicable &&
                <DividerSection removeDivider>
                    <WysiwygWithReactLink content={AEProps.annualEnrollmentNotApplicablePlanRateMessage} />
                </DividerSection>
            }
            <MyCPGCoverageCostSummary
                medicalAvailable={
                    AEState?.AEInfo?.offerings?.M?.plans?.length > 0 && !!AEState?.AEInfo?.enrollments_base?.M?.[0]
                }
                medicalAmount={medicalRate}
                medicalDeclined={!selectedMedicalPlanName}
                dentalAvailable={
                    AEState?.AEInfo?.offerings?.D?.plans?.length > 0 && !!AEState?.AEInfo?.enrollments_base?.D?.[0]
                }
                dentalAmount={dentalRate}
                dentalDeclined={!selectedDentalPlanName}
                coverageSummaryTitle={AEProps?.coverageSummaryTitle}
                medicalLabel={selectedMedicalPlanName}
                dentalLabel={selectedDentalPlanName}
                costSummaryTotalLabel={AEProps?.coverageSummaryTotalLabel}
                monthlyCostLabel={AEProps?.coverageSummaryMonthlyCostLabel}
                monthlyCostDescription={AEProps?.coverageSummaryMonthlyCostDescription}
                monthlyCostTooltip={AEProps?.coverageSummaryMonthlyCostTooltip}
            />
        </>
    );
}